import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { AppWagmiProvider } from "providers/AppWagmiProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AppWagmiProvider>
      <HashRouter>
        <App />
      </HashRouter>
  </AppWagmiProvider>
);
